import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import ScorecardSource from 'sources/ScorecardSource';

class ScorecardActions {
  constructor() {
    this.generateActions(
      ...generateAsyncActions(
        'fetchScorecardsForDepartment',
        'fetchScorecardQuestionById',
        'fetchScorecard'
      )
    );
  }
  fetchScorecardsForDepartment(departmentId, params) {
    return dispatch => {
      dispatch();
      return ScorecardSource.fetchScorecardsForDepartment(departmentId, params).then(
        this.fetchScorecardsForDepartmentSuccess,
        this.fetchScorecardsForDepartmentFailure
      );
    };
  }
  fetchScorecardQuestionById(questionId) {
    return dispatch => {
      dispatch(questionId);
      return ScorecardSource.fetchScorecardQuestionById(questionId).then(
        this.fetchScorecardQuestionByIdSuccess,
        this.fetchScorecardQuestionByIdError
      );
    };
  }
  fetchScorecard(id) {
    return dispatch => {
      dispatch();
      return ScorecardSource.fetch(id).then(this.fetchScorecardSuccess, this.fetchScorecardError);
    };
  }
}

export default alt.createActions(ScorecardActions);
